import * as actionTypes from '../actions';
import Cookie from 'js-cookie';
import axios from 'axios';

// import jwt from 'jsonwebtoken';
import { jwtSecret } from '../../config/default';

let logout;
const setAuthHeader = (data) => {
    const token = `Barer ${data.token}`;
    Cookie.set("tkn", token, {expires: 7 });
    axios.defaults.headers.common["Authorization"] = token;
};

function getCookieValue(a) {
    var b = document.cookie.match("(^|;)\\s*" + a + "\\s*=\\s*([^;]+)");
    return b ? b.pop() : "";
};

const logOutIfTokenExp = (logoutTime) => (dispatch) => {
    console.log("Loging out after " + logoutTime / 1000 + " Sec");
    logout = setTimeout(() => {
        clearTimeout(logout);
        console.log("Token expired, loging out");
        dispatch(logoutUser());
    }, logoutTime);
};

export const setAuthenticationMethod = (method) => (dispatch) => {
    if (method === 'SSO') {
        dispatch({ type: actionTypes.SET_AUTHENTICATION_METHOD_SSO });
    } else if (method === 'IDM') {
        dispatch({ type: actionTypes.SET_AUTHENTICATION_METHOD_IDM });
    } else if (method === 'LOCAL') {
        dispatch({ type: actionTypes.SET_AUTHENTICATION_METHOD_LOCAL });
    }
}

export const setUser = (user) => (dispatch) => {
    dispatch({ type: actionTypes.SET_USER, user: user });
    dispatch({ type: actionTypes.STOP_LOADING_USER });
};

export const idmLoginUser = async (username, password) => {
    try {
        const res = await axios.post("/api/idmLogin", {username: username, password: password });
        return res;
    } catch (err) {
        console.error(err);
        return err;
    }
};

export const localLoginUser = async (username, password) => {
    try {
        const res = await axios.post("/api/localLogin", {username: username, password: password });
        return res;
    } catch (err) {
        console.error(err);
        return err;
    }
};

export const loginUser = (auth) => {
    auth.signinRedirect();
};

export const userRole = async () => {
    try {
        // const userRole = await axios.get('/api/getUserRole');
        var userRoleData = null;
        await axios
            .get('/api/getUserRole')
            .then((res) => {
                userRoleData = res.data.response;
            })
            .catch((err) => {
                console.error(err);
            });
        // return userRole.data.response;
        return userRoleData;
    } catch (err) {
        console.error(err);
        return err;
    }
};

export const checkUser = (history) => (dispatch) => {
    dispatch({ type: actionTypes.LOADING_USER });
    axios
        .get("/api/user")
        .then((res) => {
            const logoutTime = getCookieValue("lo");
            dispatch(logOutIfTokenExp(logoutTime));
            dispatch({ type: actionTypes.SET_USER, payload: res.data.user });
            dispatch({ type: actionTypes.STOP_LOADING_USER });
        })
        .catch((err) => {
            console.error(err);
            dispatch({ type: actionTypes.STOP_LOADING_USER });
            logoutUser();
        });
};

export const logoutUser = () => async (dispatch) => {
    Cookie.remove("lo");
    Cookie.remove("lou");
    Cookie.remove("tkn");
    Cookie.remove("user");
    delete axios.defaults.headers.common["Authorization"];
    dispatch({ type: actionTypes.SET_UNAUTHENTICATED });
};